export { View as DisclaimerMain } from './view'
